import { Injectable } from '@angular/core';
import { NodeDetailModel } from 'src/app/models/node.model';
import { ImageCanvasModel } from 'src/app/models/fabric.model';
import { fabric } from 'fabric';
import * as cloneDeep from 'lodash/cloneDeep';
@Injectable({
    providedIn: 'root'
  })
export class FabricService {
    NODE_COLOR_SENSOR = "#F9D124";
    NODE_COLOR_LEVEL = "#F39C12";
    NODE_COLOR_LOAD = "#428BCA";

    constructor() { }
    public getMousePosition = (canvasId: string, clientX: number, clientY: number) => {
        const rect = document.getElementById(canvasId).getBoundingClientRect();
        return {
            x: clientX - rect.left,
            y: clientY - rect.top
        };
    }
    public fabricRect = (nodeDetail: NodeDetailModel): fabric.Rect => {
        return new fabric.Rect(this.rectOptions(nodeDetail));
    }
    public fabricTextInRect = (nodeDetail: NodeDetailModel): any => {
        return new fabric.Text(nodeDetail.nodeName, this.textOptions(nodeDetail));
    }
    public fabricIdInRect = (nodeDetail: NodeDetailModel): any => {
        return new fabric.Text(nodeDetail.selectedEnity, this.textOptions1(nodeDetail));
    }

    public fabricSensorIdInRect = (nodeDetail: NodeDetailModel): any => {
        return new fabric.Text(nodeDetail.sensorRIdForSelectedEnity, this.textOptions1(nodeDetail));
    }
    private textOptions = (nodeDetail: NodeDetailModel):  any => {
            return <any>{
              left: nodeDetail.fabricOption.left + 3,
              top: nodeDetail.fabricOption.top + 5,
              selectable:  false,
              strokeWidth:  1,
              // stroke: HM_COLOR_STATION_BORDER,
              // fill: 'blue',
            fontSize: 12,
            fontWeight: 'bold',
                fontFamily: 'Bosch-Sans',
            };
    }
    private textOptions1 = (nodeDetail: NodeDetailModel): any => {
        return <any>{
            left: nodeDetail.fabricOption.left + 3,
            top: nodeDetail.fabricOption.top + 5,
            selectable: false,
            strokeWidth: 0,
            opacity: 0,
            // stroke: HM_COLOR_STATION_BORDER,
            // fill: 'blue',
            fontSize: 1, // Fix unexpected border of seleted node
            fontWeight: 'bold',
            fontFamily: 'Bosch-Sans',
        };
    }

    private rectOptions = (nodeDetail: NodeDetailModel): any => {        
        return <any>{
            id: nodeDetail.nodeId,
            left: nodeDetail.fabricOption.left,
            top: nodeDetail.fabricOption.top,
            width: nodeDetail.fabricOption.width,
            height: nodeDetail.fabricOption.height,
            selectable: false,
            strokeWidth: 1,
            stroke: 'blue',
            // stroke: HM_COLOR_STATION_BORDER,
            fill: this.getNodeColor(nodeDetail),
            hoverCursor: 'pointer',
            opacity: 1,
            nodeId: nodeDetail.nodeId,
            nodeName: nodeDetail.nodeName,
            selectedInputSensors: nodeDetail.selectedInputSensors,
            selectedOutputSensors: nodeDetail.selectedOutputSensors,
            inputSensorCriteria: nodeDetail.inputSensorCriteria,
            outputSensorCriteria: nodeDetail.outputSensorCriteria,
            load: nodeDetail.load,
        };
    }
    
    // Canvas on Form 12
    public fabricRectonTree = (nodeDetail: NodeDetailModel): fabric.Rect => {
        return new fabric.Rect(this.rectOptionsonTree(nodeDetail));
    }

    private rectOptionsonTree = (nodeDetail: NodeDetailModel): any => {
        return <any>{
            id: nodeDetail.nodeId,
            left: nodeDetail.fabricOption.left,
            top: nodeDetail.fabricOption.top,
            width: nodeDetail.fabricOption.width,
            height: nodeDetail.fabricOption.height,
            selectable: false,
            strokeWidth: 1,
            stroke: 'blue',
            // stroke: HM_COLOR_STATION_BORDER,
            fill: this.getNodeColor(nodeDetail),
            hoverCursor: 'pointer',
            opacity: 1,
            nodeId: nodeDetail.nodeId,
            nodeName: nodeDetail.nodeName,
            selectedEnity: nodeDetail.selectedEnity,
            assignSensor: nodeDetail.assignSensor,
            sensorRIdForSelectedEnity: nodeDetail.sensorRIdForSelectedEnity,
        };
    }

    private getNodeColor(nodeDetail: NodeDetailModel) {
        let color = this.NODE_COLOR_LEVEL;
        if (nodeDetail.assignSensor) {
            color = this.NODE_COLOR_SENSOR;
        }
        if (nodeDetail.load !== undefined) {
            color = this.NODE_COLOR_LOAD;
        }

        return color;
    }
}
